import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("i", {
      class: "icon-nav-information",
      style: _normalizeStyle({ color: _ctx.color })
    }, null, 4)
  ])), [
    [
      _directive_tooltip,
      {
      value: `${_ctx.title}`,
      escape: false,
      class: `${_ctx.customClass}`,
    },
      void 0,
      { top: true }
    ]
  ])
}